import React from 'react';
import { Box, ListItemAvatar } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const Loading = () => (
  <>
    <ListItemAvatar>
      <Skeleton variant="circle" width={48} height={48} />
    </ListItemAvatar>
    <Box className="item-text-container">
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="text" width="35%" />
    </Box>
    <Skeleton
      variant="circle"
      width={24}
      height={24}
      className="item-icon-go"
    />
  </>
);

export default Loading;
